import(/* webpackMode: "eager" */ "/var/www/dev-716-cannabis/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/dev-716-cannabis/components/marketing/promo-banner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/dev-716-cannabis/components/shared/age-verification.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/dev-716-cannabis/components/shared/cart-drawer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/dev-716-cannabis/components/shared/navbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/var/www/dev-716-cannabis/components/theme-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/dev-716-cannabis/components/ui/direct-image.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/dev-716-cannabis/components/ui/error-boundary.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CartProvider"] */ "/var/www/dev-716-cannabis/lib/context/cart-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SpecialsProvider"] */ "/var/www/dev-716-cannabis/lib/context/specials-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UserSessionProvider"] */ "/var/www/dev-716-cannabis/lib/context/user-session-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/var/www/dev-716-cannabis/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/var/www/dev-716-cannabis/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/var/www/dev-716-cannabis/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Poppins\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"400\",\"500\",\"600\",\"700\"],\"variable\":\"--font-poppins\"}],\"variableName\":\"poppins\"}");
;
import(/* webpackMode: "eager" */ "/var/www/dev-716-cannabis/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Staatliches\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"400\"],\"variable\":\"--font-staatliches\"}],\"variableName\":\"staatliches\"}");
